/**
 *
 * AuthPageWrapper
 *
 */
import { memo, ReactNode } from 'react';

import { Icon } from 'app/components/Icon';

import { Container, Col, Row, Hidden, FlexCol, Div } from 'styles/__layout';
import * as S from 'app/pages/AuthPages/AuthPageWrapper/styles';

interface Props {
  children: ReactNode;
  bgImage: string;
  component?: ReactNode | JSX.Element;
}

export const AuthPageWrapper = memo(({ children, bgImage, component = null }: Props) => {
  return (
    <S.Wrapper>
      <Container fluid bg="sands.2" width="100%" p={0}>
        <Row height="100%" m={0}>
          <Col md={6} bg="cream.0" px="78px" py="40px">
            <FlexCol alignItems="center">
              <Div mb="40px" width="100%" maxWidth="520px">
                <Icon icon="unmind-full-logo-dark" height="52px" width="194px" />
              </Div>
              {children}
            </FlexCol>
          </Col>
          <Hidden xs sm>
            <Col md={6} p={0}>
              <S.BgImageWrapper image={bgImage}>{component}</S.BgImageWrapper>
            </Col>
          </Hidden>
        </Row>
      </Container>
    </S.Wrapper>
  );
});
